// extracted by mini-css-extract-plugin
module.exports = {"well":"jUzxtEhV3T1bouw4fkhg"};